module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workshops-bespoke"
  }, [_c('nav-1'), _vm._v(" "), _c('hero', {
    attrs: {
      "image": _vm.hero
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "products-wrapper"
  }, [_c('h2', [_vm._v("Sample Bespoke Workshops")]), _vm._v(" "), _c('div', {
    staticClass: "products size__content__wide pos__content__center"
  }, _vm._l((_vm.products), function(p, index) {
    return _c('div', {
      staticClass: "product"
    }, [_c('h2', {
      staticClass: "--flash",
      domProps: {
        "innerHTML": _vm._s(p.title)
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(p.text))]), _vm._v(" "), _c('ul', _vm._l((p.key), function(k) {
      return _c('li', [_vm._v(_vm._s(k))])
    })), _vm._v(" "), _vm._m(1, true)])
  })), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-text"
  }, [_c('h1', [_vm._v("Private & Corporate Workshops")]), _vm._v(" "), _c('h4', {
    staticClass: "size__content__default pos__content__center"
  }, [_vm._v("\n      A Learn with Hato workshop is a great way to celebrate an event or bring colleagues together. We have hosted zine-making, typeface design, terrarium-building and other creative workshops in the past. With an in-house team of design & printing experts and a network of creative collaborators, our curated experiences are tailored to your specific requirements – in‑house or offsite, analog or digital, party or masterclass. Take a look at these sample bespoke workshops:\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action"
  }, [_c('a', {
    attrs: {
      "href": "mailto:bespoke@hatopress.net"
    }
  }, [_vm._v("Enquire")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action"
  }, [_c('h3', [_vm._v("Not what you’re looking for? Let us customise your next event with a bespoke workshop.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:bespoke@hatopress.net?subject=Bespoke Workshops"
    }
  }, [_vm._v("bespoke@hatopress.net")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+44-207-729-5585"
    }
  }, [_vm._v("+44 (0)207 729 5585")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes size__content__wide pos__content__center"
  }, [_c('div', {
    staticClass: "quote"
  }, [_c('h3', [_vm._v("“Our creative team loved the chance to roll up our sleeves and learn risoprinting from one of the finest studios in London. The session was well run. Hats off to Hato.”")]), _vm._v(" "), _c('p', [_vm._v("Shirley, Senior Copywriter, Virgin Media")])]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('h3', [_vm._v("“The two colour workshop was perfect for our group to experiment and get creative. We learnt loads and would recommend to anyone!”")]), _vm._v(" "), _c('p', [_vm._v("Emma, Graphic Designer, Boden")])]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('h3', [_vm._v("“We have a great Riso printing session at Hato, really learnt a lot and was great fun. Was a great way to work on something different whilst enjoying a beer ;-).”")]), _vm._v(" "), _c('p', [_vm._v("Alex Prior, Head of Graphic Design at The Hoxton")])]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('h3', [_vm._v("“The Hato Christmas Card workshop was the perfect activity for the team to get out the office and learn and do something new together. The instructors were amazing, offering motivation and tips throughout. We came away with a new appreciation for the risograph print process, along with some fantastic printed cards (some showing more creative skill than others!).”")]), _vm._v(" "), _c('p', [_vm._v("Helen Scibilia, Project Manager, YCN")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-logos"
  }, [_c('img', {
    staticClass: "size__content__narrow",
    attrs: {
      "src": require("../assets/clients/corporate-logo-blocks.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-523c29fc","transformToRequire":{"img":"src","audio":"src","video":"poster"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkshopsBespoke.vue
// module id = 215
// module chunks = 1